module.exports = __webpack_public_path__ + "img/placeholder-avatar.b75affd5.svg";